<template>
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <div class="table">
          <table class="table">
            <thead class=" text-primary">
              <tr>
                <th>
                  Role
                </th>
                <th>
                  Account
                </th>
                <th>
                  Name
                </th>
                <th>
                  Phone
                </th>
                <th>
                  Email
                </th>
                <th>
                  <router-link v-if="$dataManager.getters.permissions.User.includes('create')" :to="{name:'User.Create'}">
                    <div class="btn btn-xs btn-success btn-round pull-right">Create</div>
                  </router-link>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in users" :key="i">
                <td v-text="item.roleName" />
                <td v-text="item.account" />
                <td v-text="item.name" />
                <td v-text="item.phone" />
                <td v-text="item.email" />
                <td>
                  <router-link :to="{name:'User.Detail',params:{id:item.id}}">
                    <div class="btn btn-xs btn-primary  pull-right">Detail</div>
                  </router-link>
                <!--                <router-link :to="{name:'User.Update',params:{id:user.id}}"-->
                <!--                             v-if="$dataManager.getters.permissions.User.includes('update')">-->
                <!--                  <div class="btn btn-xs btn-primary  pull-right">Update</div>-->
                <!--                </router-link>-->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserList',
  data: function() {
    return {
      users: []
    }
  },
  computed: {},
  mounted() {
    this.getData()
  },
  methods: {
    getData: function() {
      this.$store.commit('OPEN_LOADING')
      this.$store.dispatch('getList', { type: 'User', action: 'list' }).then((res) => {
        if (!res.errorCode) {
          this.users = res.data
          this.$store.commit('CLOSE_LOADING')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
